var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.226mm",
    height: "7.44mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 240.03 159.08",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2.37,
    width: 230.53,
    height: 4.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2.37,
    y: 154.33,
    width: 230.53,
    height: 4.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M34.22 113.77c-18.9,-0 -34.22,-15.33 -34.22,-34.23 0,-18.9 15.33,-34.23 34.23,-34.23 18.9,0 34.23,15.33 34.23,34.23 0,0.09 0,0.19 0,0.28 -0.18,18.78 -15.45,33.91 -34.23,33.94l0 0zm0 -63.7c-16.27,0 -29.47,13.2 -29.47,29.47 0,16.27 13.2,29.47 29.47,29.47 16.28,0 29.47,-13.2 29.47,-29.47 -0.03,-16.27 -13.21,-29.45 -29.47,-29.47l-0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M206.09 113.77c-0.1,-0 -0.19,-0 -0.28,-0 -18.9,0 -34.23,-15.33 -34.23,-34.22 0,-18.9 15.33,-34.22 34.23,-34.22 18.9,0 34.23,15.33 34.23,34.22 0,0.09 0,0.19 0,0.28 -0.18,18.67 -15.28,33.76 -33.94,33.95l0 0zm0 -63.7c-16.28,0 -29.48,13.2 -29.48,29.47 0,16.27 13.2,29.47 29.47,29.47 16.28,0 29.47,-13.2 29.47,-29.47 0,-16.28 -13.2,-29.47 -29.47,-29.47l0 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 70.03,
    y: 77.16,
    width: 98.21,
    height: 4.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M154.38 98.89l-3.39 -3.34 16.01 -16.01 -16.01 -16.01 3.39 -3.34 19.35 19.35 -19.35 19.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M86.04 98.89l-19.35 -19.35 19.35 -19.35 3.39 3.34 -16.01 16.01 16.01 16.01 -3.39 3.34z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc25);
export default __webpack_public_path__ + "static/media/ic_2_5.d436cbd97db99b9340eef54a9cedcc15.svg";
export { ForwardRef as ReactComponent };